var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"titlePage":'Configurando seu site'}},[_c('div',{staticClass:"onboarding-create-site"},[_c('welcome')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }